import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ClipboardPlus, FileText, QrCode, Sunrise, Zap } from "lucide-react";
import api from "../lib/api";
import { StatusBadge } from "../components/StatusBadge";
import { Button } from "../components/ui/button";

export default function FrontScan() {
  const { frontId } = useParams();
  const navigate = useNavigate();
  const [front, setFront] = useState(null);
  const [etat, setEtat] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/fronts/${frontId}`).then(({ data }) => {
      setFront(data.front);
      setEtat(data.etat);
    }).catch((err) => {
      setErrorMsg(err.response?.status === 403 ? "Accès refusé — ce front appartient à un autre site." : "Front introuvable.");
    }).finally(() => setLoading(false));
  }, [frontId]);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-slate-500 font-mono uppercase text-sm">Chargement...</div>;
  }

  if (!front) {
    return (
      <div data-testid="scan-error" className="min-h-[60vh] flex items-center justify-center text-red-400 font-mono uppercase text-sm text-center px-4">
        {errorMsg}
      </div>
    );
  }

  return (
    <div data-testid="scan-landing-page" className="max-w-lg mx-auto px-4 py-16 text-center space-y-6">
      <QrCode className="w-10 h-10 text-cyan-400 mx-auto" />
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.25em] text-cyan-500 mb-1">{front.Front_ID}</div>
        <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-slate-50 mb-3">{front.Front_Libelle}</h1>
        <StatusBadge status={etat?.Statut_Global} testId="scan-status-badge" />
      </div>
      <div className="flex flex-col gap-3 pt-2">
        <Button data-testid="scan-btn-new-inspection" onClick={() => navigate(`/inspection/new/${frontId}`)} className="h-14 bg-cyan-500 hover:bg-cyan-400 text-black font-bold uppercase text-sm">
          <ClipboardPlus className="w-5 h-5 mr-2" /> Inspection bimensuelle
        </Button>
        <Button data-testid="scan-btn-avant-poste" onClick={() => navigate(`/visite/nouvelle/avant-poste?front=${frontId}`)} variant="outline" className="h-14 border-slate-700 text-slate-200 font-bold uppercase text-sm">
          <Sunrise className="w-5 h-5 mr-2" /> Visite avant poste
        </Button>
        <Button data-testid="scan-btn-apres-tir" onClick={() => navigate(`/visite/nouvelle/apres-tir?front=${frontId}`)} variant="outline" className="h-14 border-slate-700 text-slate-200 font-bold uppercase text-sm">
          <Zap className="w-5 h-5 mr-2" /> Visite après tir
        </Button>
        <Button data-testid="scan-btn-view-front" onClick={() => navigate(`/front/${frontId}`)} variant="outline" className="h-14 border-slate-700 text-slate-200 font-bold uppercase text-sm">
          <FileText className="w-5 h-5 mr-2" /> Voir la fiche
        </Button>
      </div>
    </div>
  );
}
